import {
    createContext,
    useCallback,
    useContext,
    useEffect,
    useRef,
    useState,
  } from "react";
  import GlobalContext from "../../framework/GlobalContext";
  
  const DoctorCommissionProgramContext = createContext();
  
  export const DoctorCommissionProgramContextProvider = ({ children }) => {
    const {
      currentComponent,
      autocompleteOpen,
      focusLastRow,
      setFocusLastRow,
      showSpotlight,
    } = useContext(GlobalContext);
    const [addClicked, setAddClicked] = useState(false);
      const doctorCommissionProgramGridRef = useRef();
    const doctorCommissionProgramRef = useRef();
    const doctorCommissionProgramStartDateRef = useRef();
    const doctorCommissionProgramEndDateRef = useRef();
    const doctorCommissionProgramManufacturerGroupRef = useRef();
    const doctorCommissionProgramGenericMedicineCategoryRef = useRef();
    const doctorCommissionProgramDoctorTypeRef = useRef();
    const saveDoctorCommissionProgramRef = useRef();
    const addClickedRef = useRef();
    const default_focus = doctorCommissionProgramGridRef;
  
    const listener = useCallback((event) => {
      const key = event.key?.toLowerCase();
      const ctrlKey = event.ctrlKey;
      if (ctrlKey && key === "s") {
        saveDoctorCommissionProgramRef.current.click();
        return;
      }
      if (key === "+") {
        addClickedRef.current.click();
        return;
      }
    }, []);
  
    useEffect(() => {
      if (!currentComponent || currentComponent === "default_focus") {
        setTimeout(() => {
          default_focus.current?.focus();
        }, 100);
        return;
      } else if (currentComponent === "grid_doctor_commission_program") {
        if (
          doctorCommissionProgramGridRef?.current?.api?.getSelectedNodes()?.length === 0
        ) {
          doctorCommissionProgramGridRef?.current?.focus(focusLastRow);
          setTimeout(() => setFocusLastRow(true), 100);
        } else {
          doctorCommissionProgramGridRef?.current?.focus(false);
        }
        return;
      }
    }, [currentComponent, doctorCommissionProgramGridRef, default_focus, focusLastRow, setFocusLastRow]);
  
    useEffect(() => {
      if (!autocompleteOpen && !showSpotlight)
        document.addEventListener("keyup", listener, false);
      return () => {
        document.removeEventListener("keyup", listener, false);
      };
    }, [autocompleteOpen, listener, showSpotlight]);
  
    return (
      <DoctorCommissionProgramContext.Provider
        value={{
          doctorCommissionProgramGridRef,
          doctorCommissionProgramRef,
          doctorCommissionProgramStartDateRef,
          doctorCommissionProgramEndDateRef,
          doctorCommissionProgramManufacturerGroupRef,
          doctorCommissionProgramGenericMedicineCategoryRef,
          doctorCommissionProgramDoctorTypeRef,
          addClicked,
          setAddClicked,
          saveDoctorCommissionProgramRef,
          addClickedRef,
        }}
      >
        {children}
      </DoctorCommissionProgramContext.Provider>
    );
  };
  export default DoctorCommissionProgramContext;
  